import React from "react";
import { Table, Text, Button, Stack } from "@mantine/core";
import { IconUserPlus, IconFilterOff } from "@tabler/icons-react";

interface EmptyStateProps {
  onInviteClick: () => void;
  hasFiltersApplied?: boolean;
  searchQuery?: string;
  statusFilter?: string | null;
  showArchivedClients?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  onInviteClick,
  hasFiltersApplied = false,
  searchQuery = "",
  statusFilter = null,
  showArchivedClients = false,
}) => {
  const getEmptyMessage = () => {
    if (searchQuery) {
      return `No clients found matching "${searchQuery}".`;
    }
    if (statusFilter) {
      return `No clients with status "${statusFilter}".`;
    }
    if (showArchivedClients) {
      return "No archived clients found.";
    }
    if (hasFiltersApplied) {
      return "No clients match your current filters.";
    }
    return "No clients available.";
  };

  const getEmptySubMessage = () => {
    if (hasFiltersApplied || searchQuery || statusFilter) {
      return "Try adjusting your filters or search query.";
    }
    return "Get started by inviting your first client.";
  };

  const showInviteButton = !hasFiltersApplied && !searchQuery && !statusFilter;

  return (
    <Table.Tr>
      <Table.Td colSpan={5}>
        <div className="no-clients-container">
          <div className="no-clients-content">
            <Stack align="center" gap="md">
              <Text size="lg" fw={500} c="dimmed">
                {getEmptyMessage()}
              </Text>
              <Text size="sm" c="dimmed">
                {getEmptySubMessage()}
              </Text>
              {showInviteButton ? (
                <Button
                  className="invite-client-button"
                  onClick={onInviteClick}
                  variant="filled"
                  color="blue"
                  leftSection={<IconUserPlus />}
                  size="lg"
                >
                  Invite A Client
                </Button>
              ) : (
                <Button
                  variant="outline"
                  color="gray"
                  leftSection={<IconFilterOff />}
                  size="md"
                  onClick={() => window.location.reload()}
                >
                  Clear All Filters
                </Button>
              )}
            </Stack>
          </div>
        </div>
      </Table.Td>
    </Table.Tr>
  );
};
